export function OrgSettingsSectionKbPilot(props: {
  kbTestingModeEnabled: boolean;
  setKbTestingModeEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  onSaveKbTestingMode: () => void | Promise<void>;
}) {
  const { kbTestingModeEnabled, setKbTestingModeEnabled, onSaveKbTestingMode } = props;
  return (
    <div className="pt-2 border-t border-gray-100">
      <div className="mb-3 rounded-lg border border-indigo-200 bg-indigo-50 p-3">
        <p className="text-xs font-semibold text-indigo-900">KB testing mode (pilot)</p>
        <p className="mt-1 text-[11px] text-indigo-900/80">
          When enabled, Ask & policies uses a structured feedback form (exact phrasing, expected answer, what was wrong,
          one-sentence impact) and writes submissions into the KB Gap Inbox tagged for testing follow-up.
        </p>
        <label className="mt-2 inline-flex items-center gap-2 text-xs text-indigo-900">
          <input
            type="checkbox"
            checked={kbTestingModeEnabled}
            onChange={(e) => setKbTestingModeEnabled(e.target.checked)}
          />
          Enable KB testing mode for this org
        </label>
        <div className="mt-2">
          <button
            type="button"
            onClick={() => void onSaveKbTestingMode()}
            className="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-xs hover:bg-indigo-700"
          >
            Save KB testing mode
          </button>
        </div>
      </div>
    </div>
  );
}
